import { createApp } from 'vue';
import { createPinia } from 'pinia';
import router from './router';
import App from './App.vue';
import { extractShopIdFromUrl } from './utils/shopHelper';
import VChart from 'vue-echarts';
// Extract shop ID from URL on app load
extractShopIdFromUrl();
const app = createApp(App);
app.use(createPinia());
app.use(router);
// Register VChart component globally
app.component('VChart', VChart);
app.mount('#app');
